import axios from "@/axios";

export const namespaced = true

export const state = {
    fiscalYears: [],
    fiscalYearsAsStrings: []
}

export const getters = {
    fiscalYears: function (state) {
            return state.fiscalYears;
        },
        fiscalYearsAsStrings: function (state) {
            return state.fiscalYearsAsStrings;
        }
}
    
export const mutations = {
        SET_FISCAL_YEARS: (state, response) => (state.fiscalYears = response.data),
        SET_FISCAL_YEARS_AS_STRINGS: (state, response) => (state.fiscalYearsAsStrings = response.data),
}

export const actions = {
        async getFiscalYears({commit}) {
            commit('SET_FISCAL_YEARS', await axios.get("/api/fiscalyears"))
        },
        async getFiscalYearsAsStrings({commit}) {
            commit('SET_FISCAL_YEARS_AS_STRINGS', await axios.get("/api/fiscalyears/string"))
        }
}
